import React, { FC } from "react";
import { ChipProps } from "../../interfaces/chip.interface";
import { motion } from "framer-motion";

const Chip: FC<ChipProps> = ({
    text,
    icon: Icon,
    ...motionProps
}) => {
    return (
        <motion.div 
            className="chip-enhanced d-flex align-items-center"
            {...motionProps}
        >
            {Icon && (
                <Icon className="chip-icon me-3 flex-shrink-0" />
            )}
            <span className="chip-text">{text}</span>
        </motion.div>
    );
};

export default Chip;